import React, { useEffect, useRef } from 'react';
import { useGoogleSignIn } from '@/hooks/useGoogleSignIn';

interface GoogleSignInButtonProps {
  onSuccess?: () => void;
}

export default function GoogleSignInButton({ onSuccess }: GoogleSignInButtonProps) {
  const { renderButton } = useGoogleSignIn(onSuccess);
  const cleanupRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    cleanupRef.current = renderButton('google-signin-btn') || null;
    return () => {
      cleanupRef.current?.();
    };
  }, [renderButton]);

  return (
    <div
      id="google-signin-btn"
      className="w-full flex items-center justify-center min-h-[44px]"
    />
  );
}
